module.exports = __webpack_public_path__ + "static/media/background.c896fa6e.png";